// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v0.0.6-0-gf79f450",
    "hash": "gf79f450",
    "distance": 0,
    "tag": "v0.0.6",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.0.6",
        "major": 0,
        "minor": 0,
        "patch": 6,
        "prerelease": [],
        "build": [],
        "version": "0.0.6"
    },
    "suffix": "0-gf79f450",
    "semverString": "0.0.6",
    "version": "0.0.6"
};
